module.exports = __webpack_public_path__ + "static/media/prizeRankIcon.1c5f3d30.png";